import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { authAPI } from '../../services/api';

const ForgotPasswordPage = () => {
  const [email,   setEmail]   = useState('');
  const [loading, setLoading] = useState(false);
  const [sent,    setSent]    = useState(false);
  const [error,   setError]   = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    if (!email.trim()) { setError('أدخل بريدك الإلكتروني'); return; }
    setLoading(true);
    try {
      await authAPI.forgotPassword({ email: email.trim().toLowerCase() });
      setSent(true);
    } catch {
      setError('حدث خطأ، حاول مجدداً');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div dir="rtl" className="min-h-screen bg-[#F5F9FF] flex items-center justify-center px-4">
      <div className="w-full max-w-md bg-white rounded-2xl shadow-[0_4px_24px_rgba(30,64,175,.10)] p-8">

        {/* Logo */}
        <div className="text-center mb-6">
          <div className="inline-flex items-center justify-center w-14 h-14 rounded-2xl bg-[#1E40AF] text-white text-2xl font-black mb-3">س</div>
          <h1 className="text-xl font-black text-gray-900">استعادة كلمة المرور</h1>
          <p className="text-sm text-gray-500 mt-1">سافر للنقل</p>
        </div>

        {sent ? (
          <div className="text-center">
            <div className="text-5xl mb-4">📧</div>
            <h2 className="text-lg font-bold text-gray-800 mb-2">تحقق من بريدك الإلكتروني</h2>
            <p className="text-sm text-gray-500 leading-relaxed mb-6">
              إذا كان البريد الإلكتروني <span className="font-semibold text-gray-700">{email}</span> مسجلاً لدينا،
              ستصلك رسالة تحتوي على رابط إعادة تعيين كلمة المرور خلال دقائق.
              تحقق من مجلد الرسائل غير المرغوب فيها (Spam) إذا لم تجد الرسالة.
            </p>
            <Link to="/login" className="block w-full text-center bg-[#1E40AF] hover:bg-[#1D4ED8] text-white font-bold py-3 rounded-xl transition-colors">
              العودة لتسجيل الدخول
            </Link>
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="space-y-4">
            <p className="text-sm text-gray-600 leading-relaxed mb-2">
              أدخل بريدك الإلكتروني المسجل وسنرسل لك رابطاً لإعادة تعيين كلمة المرور.
            </p>

            <div>
              <label className="block text-sm font-bold text-gray-700 mb-1.5">البريد الإلكتروني</label>
              <input
                type="email"
                value={email}
                onChange={(e) => { setEmail(e.target.value); setError(''); }}
                placeholder="example@email.com"
                dir="ltr"
                className="w-full border border-gray-200 rounded-xl px-4 py-3 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>

            {error && <p className="text-red-600 text-sm font-semibold">{error}</p>}

            <button
              type="submit"
              disabled={loading}
              className="w-full bg-[#1E40AF] hover:bg-[#1D4ED8] disabled:opacity-60 text-white font-bold py-3 rounded-xl transition-colors"
            >
              {loading ? 'جاري الإرسال...' : 'إرسال رابط الاستعادة'}
            </button>

            <Link to="/login" className="block text-center text-sm text-gray-500 hover:text-[#1E40AF] font-semibold mt-2 transition-colors">
              ← العودة لتسجيل الدخول
            </Link>
          </form>
        )}
      </div>
    </div>
  );
};

export default ForgotPasswordPage;
